export const getTransformString = ({ x, y, rotation }) =>
  `translate(${x}px, ${y}px) rotate(${rotation}deg)`;



// WEBPACK FOOTER //
// /src/components/Drift/Drift.helpers.js